import { IconFont } from '@/components/IconFont'
import { login } from '@/services/passport/passport.service'
import { APP_NAME } from '@/utils/constants'
import { useRequest, useTitle } from 'ahooks'
import { Button, Form, Input } from 'antd'
import React, { memo, useState } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { VerifyEmail } from './VerifyEmail'

export default memo(function Login() {
  useTitle(`${APP_NAME}-Login`)
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [verified, setVerified] = useState(true)
  const { loading, run } = useRequest(login, {
    manual: true,
    onSuccess: () => {
      const url = searchParams.get('redirect_from') || '/'
      navigate(url)
    },
    onError: (e: any) => {
      const data = e.data;
      if (data.errorCode === "EMAIL_NOT_VERIFIED") {
        setVerified(false)
      }
    }
  })

  if (!verified) {
    return <VerifyEmail email={form.getFieldValue('email')} />
  }

  return (
    <Form
      form={form}
      autoComplete='off'
      layout='vertical'
      onFinish={(values) => {
        run(values)
      }}
    >
      <Form.Item
        label='Email'
        name='email'
        rules={[
          { required: true, message: 'Please enter email address' },
          { type: 'email', message: 'Invalid email format' }
        ]}
      >
        <Input size='large' type='email' prefix={<IconFont type={'icon-email'} />} placeholder='Enter email address' />
      </Form.Item>

      <Form.Item
        label='Password'
        name='password'
        rules={[
          { required: true, message: 'Please enter password' },
          { min: 6, message: 'Minimum length of password is 6 digits.' },
          { max: 20, message: 'Maximum length of password is 20 digits.' }
        ]}
      >
        <Input
          size='large'
          autoComplete='new-password'
          prefix={<IconFont type={'icon-lock'} />}
          type='password'
          placeholder='Enter password'
        />
      </Form.Item>
      <div className='flex-end mb-2'>
        <a href='/entrance/forgot-password' style={{color: '#037C4B'}}>Forgot Password or Recover Account?</a>
      </div>

      <Form.Item>
        <Button
          htmlType='submit'
          type='primary'
          size='large'
          loading={loading}
          style={{ width: '100%', marginBottom: '5px' }}
        >
          Login
        </Button>
      </Form.Item>
    </Form>
  )
})
